import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";

export const SidebarData = {
  admin: [
    {
      title: "Simulador",
      path: "/simulador",
      icon: <AiIcons.AiOutlineLaptop />,
      cName: "nav-text",
    },
    {
      title: "Simulações",
      path: "/simulacoes",
      icon: <IoIcons.IoIosPaper />,
      cName: "nav-text",
    },
    {
      title: "Dashboard",
      path: "/dashboard",
      icon: <AiIcons.AiOutlineBarChart />,
      cName: "nav-text",
    },
    {
      title: "Cadastro",
      path: "/cadastro",
      icon: <AiIcons.AiOutlineProfile />,
      cName: "nav-text",
    },
    {
      title: "Empresas",
      path: "/empresas",
      icon: <AiIcons.AiFillProject />,
      cName: "nav-text",
    },
    {
      title: "Clientes",
      path: "/clientes",
      icon: <AiIcons.AiFillDashboard />,
      cName: "nav-text",
    },
    {
      title: "Cidades",
      path: "/cidades",
      icon: <FaIcons.FaCity />,
      cName: "nav-text",
    },
  ],
};
